import React, { useContext } from 'react';
import { BaseContext } from '../../contexts';
import Landing from '../conceptCommon/pages/landing';
import MainPlan from '../conceptCommon/pages/mainPlan';
import { addPlanViewed, clickMorePlans } from '../../statistics';
import Plans from './pages/plans';

const ConceptList = () => {
  const {
    page, setPage, onBack, mainPlan, onSelectMainPlan, onSelectPlan
  } = useContext(BaseContext);

  const handleOnGetStarted = () => {
    addPlanViewed(mainPlan.id);
    setPage("mainPlan");
  };

  const handleOnMorePlans = () => {
    clickMorePlans();
    setPage("plans");
  };

  return (
    <div className="layout">
      <div className="container">
        <div className="content">
          { page === "landing" && <Landing onGetStarted={ handleOnGetStarted } /> }
          {
            page === "mainPlan" &&
            <MainPlan
              plan={ mainPlan }
              onBack={ onBack }
              onSelect={ onSelectMainPlan }
              onMorePlans={ handleOnMorePlans }
            />
          }
          { page === "plans" && <Plans onBack={ onBack } onSelect={ onSelectPlan } /> }
        </div>
      </div>
    </div>
  );
};

export default ConceptList;
